import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { loadMetaPixel, pageView } from "@/lib/metaPixel";

export default function MetaPixel() {
  const location = useLocation();
  const initialized = useRef(false);

  useEffect(() => {
    loadMetaPixel();
  }, []);

  useEffect(() => {
    // Base code already fired the first PageView on load; only track subsequent route changes.
    if (!initialized.current) {
      initialized.current = true;
      return;
    }
    pageView();
  }, [location.pathname, location.search]);

  return null;
}
